import React, { Component } from "react";

//-- Page Components
import Plans from '../components/p2/plans.js'
import Reviews from '../components/p2/reviews/index.js'
import Header from '../components/p2/header/index.js'
import Hero from '../components/p2/hero/index.js'
import HowItWorks from '../components/p2/how-it-works/index.js'
import Benefits from '../components/p2/benefits/index.js'
import TooGood from '../components/p2/too-good/index.js'
import Faq from '../components/p2/faq/index.js'
import Recycle from '../components/p2/recycle/index.js'
import Footnotes from '../components/p2/footnotes/index.js'
import Footer from '../components/p2/footer-tmp/index.js'

//-- Embeded Pages
import SavingsSimple from './savings-simple.js'


class P2 extends Component {
    render() {
        return (
            <div style={{maxWidth: "1920px", margin: "0 auto"}}>
                <Header/>
                <Hero/>
                <HowItWorks/>
                <SavingsSimple {...this.props}/>
                <Plans/>
                <Benefits/>
                <TooGood/>
                <Reviews/>
                <Recycle/>
                <Faq/>
                <Footnotes/>
                <Footer/>
            </div>
        );
    }
}

export default P2
